import React from 'react';
import Breadcrumbs from './Breadcrumbs';

/**
 * Reusable page hero section.
 * @param {string} overline - Small text above title
 * @param {string} title - Main heading
 * @param {string} subtitle - Description text
 * @param {Array} breadcrumbs - Array for Breadcrumbs component
 * @param {string} variant - 'page' | 'dark' | 'primary'
 * @param {object} style - Additional inline styles
 * @param {React.ReactNode} children - Extra content after subtitle
 * @param {React.ReactNode} badge - Badge element before title
 */
const HeroPage = ({
  overline,
  title,
  subtitle,
  breadcrumbs,
  variant = 'page',
  style,
  children,
  badge,
  titleClassName = 'h1 hero__title',
  contentClassName = '',
  minHeight,
}) => {
  const heroClass = `hero hero--${variant}`;

  return (
    <section className={heroClass} style={{ ...style, minHeight }}>
      <div className="container">
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
        <div className={`hero__content ${contentClassName}`}>
          {badge}
          {overline && <div className="hero__overline">{overline}</div>}
          <h1 className={titleClassName}>{title}</h1>
          {subtitle && <p className="hero__subtitle">{subtitle}</p>}
          {children}
        </div>
      </div>
    </section>
  );
};

export default HeroPage;
